import { render, staticRenderFns } from "./about-us-list.vue?vue&type=template&id=f17df7ee&"
import script from "./about-us-list.vue?vue&type=script&lang=js&"
export * from "./about-us-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports